import React, { createContext } from "react"

const LoadingContext = createContext({
    loading: false,
    setLoading: () => {}
});

export { LoadingContext };